import React, { Component } from 'react';
import { connect } from 'react-redux'

import 'intl-tel-input/build/css/intlTelInput.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';

import Skins from './skins';
import { BrowserRouter } from 'react-router-dom';

import { applyTheme } from './actions/style';
import { setLanguage } from './actions/locale';
import Api from './common/api'
import Auth from './common/auth'
import Local from './common/local'
import Util from './common/util'

const SUPPORTED_LANGUAGES = ['en', 'fr'];

class App extends Component {

  constructor(props) {
    super(props);

    this.api = new Api();

    this.applyTheme = this.applyTheme.bind(this);
    this.getMuiTheme = this.getMuiTheme.bind(this);
    this.selectSkin = this.selectSkin.bind(this);
    this.resolveLanguage = this.resolveLanguage.bind(this);

    this.ensureGlobalSettings();
    this.props.dispatch(setLanguage(this.resolveLanguage()));
  }

  async componentDidMount() {
    Auth.userValidate(this.props.dispatch);
  }

  async componentWillMount() {
    await Local.readStorage();
  }

  applyTheme(theme) {
    this.props.dispatch(applyTheme(theme));
  }

  ensureGlobalSettings() {
    if (!window.globals) {
      window.globals = {
        gidBannerLink: 'https://www.versantprivacy.com/privacy',
        gidBannerMessage: 'NULL',
        gidLinkAdChoices: 'https://www.versantprivacy.com/privacy/cookies#accordionheader3',
        gidLinkCaNotice: 'https://www.versantprivacy.com/privacy/california-consumer-privacy-act',
        gidLinkDoNotSell: 'https://www.versantprivacy.com/privacy/notrtoo',
        gidLinkPrivacyOptOut: 'https://www.versantprivacy.com/privacy/notrtoo',
        gidLinkPrivacyPolicy: 'https://www.versantprivacy.com/privacy',
        gidLinkTermsAndConditions: 'https://www.versantprivacy.com/terms',
        gidShowCCPA: true,
        gid: {
          links: {
            cookiePolicy: 'https://www.versantprivacy.com/privacy/cookies',
            dataRights: 'https://www.versantprivacy.com/privacy#accordionheader5',
            privacyPolicy: 'https://www.versantprivacy.com/privacy'
          },
          privacy: {
            country: 'US',
            visible: false
          }
        }
      };
    }
  }

  getMuiTheme() {
    let theme = { ...this.props.theme };
    theme.palette.type = this.props.mode;
    return createTheme(theme);
  }

  resolveLanguage() {
    const params = Util.queryToObject(window.location.search);
    if (params.lang && SUPPORTED_LANGUAGES.includes(params.lang)) {
      return params.lang;
    }

    const browserLanguage = (navigator.language || '').slice(0, 2);
    if (SUPPORTED_LANGUAGES.includes(browserLanguage)) {
      return browserLanguage;
    }

    return 'en';
  }

  selectSkin() {
    const params = Util.queryToObject(window.location.search);
    let skinName = window.globals ? window.globals.gidSkin : '';

    if (params.hasOwnProperty('skin')) {
      skinName = params.skin;
    }

    let skin = Skins[skinName];
    if (!skin) skin = Skins.default;
    return skin;
  }

  render() {
    const theme = this.getMuiTheme();
    const Skin = this.selectSkin();

    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Skin
            applyTheme={this.applyTheme}
            loading={!this.props.user.hasValidated}
          />
        </BrowserRouter>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = state => {
  return {
    mode: state.mode,
    user: Auth.userState(state),
    theme: state.theme
  }
}

export default connect(mapStateToProps, null)(App)
